<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">
        <i class="fa-solid fa-users me-2"></i>
        <ng-container *ngIf="viewMode == ViewMode.INSERT">Benutzer anlegen</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.EDIT">Benutzer bearbeiten</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.VIEW">Benutzer</ng-container>
    </h1>
</div>

<form [formGroup]="form">
    <div class="row">
        <div class="col">
            <label>Vorname</label>
            <input type="text" class="form-control" formControlName="firstname" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.firstname }}</p>
        </div>
        <div class="col">
            <label>Nachname</label>
            <input type="text" class="form-control" formControlName="lastname" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.lastname }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>E-Mail</label>
            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                <a [href]="'mailto:' + form.value.email">{{ form.value.email }}</a>
            </p>
        </div>
        <div class="col">
            <label>Telefon</label>
            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.phone }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>Abteilung</label>
            <select class="form-control" formControlName="id_department" *ngIf="viewMode != ViewMode.VIEW">
                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let department of departments" [ngValue]="department.id">
                    {{ department.name }}
                </option>
            </select>
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.department }}
                <span class="text-muted" *ngIf="!form.value.department">Nicht gesetzt</span>
            </p>
        </div>
        <div class="col" *ngIf="viewMode != ViewMode.INSERT">
            <label>Letzter Login</label>
            <p>
                {{ form.value.last_login | date: 'dd.MM.yyyy, HH:mm' }}
                <span class="text-muted" *ngIf="!form.value.last_login">Noch nicht eingeloggt</span>
            </p>
        </div>
    </div>

    <label class="form-label">Aktiv</label>
    <div *ngIf="viewMode != ViewMode.VIEW">
        <input type="checkbox" class="form-check-input" formControlName="active">
    </div>
    <p class="gray" *ngIf="viewMode == ViewMode.VIEW">{{ form.value.active | yesNo }}</p>

    <div class="row" *ngIf="viewMode != ViewMode.VIEW">
        <div class="col">
            <label>Passwort</label>
            <input type="password" class="form-control" formControlName="password">
        </div>
        <div class="col">
            <label>Passwort wiederholen</label>
            <input type="password" class="form-control" formControlName="confirmPassword">
        </div>
    </div>
    <small class="text-muted" *ngIf="viewMode != ViewMode.VIEW">Das Passwort muss nur ausgefüllt werden, wenn es geändert werden soll</small>
</form>

<label class="form-label">Rechte</label>
<table class="table table-sm table-rights">
    <thead>
    <tr>
        <th>Name</th>
        <th>Erlaubt</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let right of rights">
        <td>{{right.name}}</td>
        <td style="width: 100px">
            <input type="checkbox" *ngIf="viewMode != ViewMode.VIEW" [(ngModel)]="right.granted">
            <div class="gray" *ngIf="viewMode == ViewMode.VIEW">
                <i class="fa-solid fa-check text-success fa-fw" *ngIf="right.granted"></i>
                <i class="fa-solid fa-times text-danger fa-fw" *ngIf="!right.granted"></i>
                {{ right.granted | yesNo }}
            </div>
        </td>
    </tr>
    </tbody>
</table>
<ng-container *ngIf="viewMode != ViewMode.VIEW">
    <button type="button" class="btn btn-secondary btn-sm float-end" (click)="toggleRights(true)">Alle</button>
    <button type="button" class="btn btn-secondary btn-sm float-end me-2" (click)="toggleRights(false)">Keine</button>
    <div class="clearfix"></div>
</ng-container>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode == ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)" *ngIf="accessService.hasRight('ADMIN')">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
        <!--<button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>-->
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
